import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMarkdown: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="markdown"><path d="M21.25 4.75H2.75V19.25H21.25V4.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6.75 14.25V9.75H7L8.9 12H9.1L11 9.75H11.25V14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M14 12.5L15.75 14.25L17.5 12.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.75 9.75V13.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconMarkdown;
